import { useCallback } from 'react';
import { useRouter } from 'expo-router';

export const useRequestLogin = () => {
  const router = useRouter();

  const requestLogin = useCallback(() => {
    router.dismissTo({
      pathname: '/(auth)/join-or-sign-in',
      params: { redirect: '/bag' },
    });
  }, [router]);

  return { requestLogin };
};
